import Cookies from "js-cookie";

export const STORAGE_KEYS = {
    AUTH_USER_DETAILS: "AUTH_USER_DETAILS",
    ANONYMOUS_USER_ID: "ANONYMOUS_USER_ID",
    LOGIN_TRIGGER: "LOGIN_TRIGGER", // 'generic' | 'personalized' | 'quota'
};

export const getAuthToken = () => {
    try {
        const admin = localStorage.getItem(STORAGE_KEYS.AUTH_USER_DETAILS);
        if (admin) {
            const { token } = JSON.parse(admin);
            return token;
        }
    } catch (error) {
        console.error('Error retrieving auth token:', error);
    }
    return null;
};

export const getAnonymousUUID = () => {
    let uuid = Cookies.get(STORAGE_KEYS.ANONYMOUS_USER_ID);
    if (!uuid) {
        uuid = generateUUID();
        Cookies.set(STORAGE_KEYS.ANONYMOUS_USER_ID, uuid, { expires: 30, secure: true, sameSite: "Strict" }); // Expire in 30 days
    }
    return uuid;
};

export const generateUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
};

// Login trigger helpers (to track why user logged in - for post-login UX)
export const setLoginTrigger = (trigger) => {
    try {
        localStorage.setItem(STORAGE_KEYS.LOGIN_TRIGGER, trigger);
    } catch {
        // ignore
    }
};

export const getLoginTrigger = () => {
    try {
        return localStorage.getItem(STORAGE_KEYS.LOGIN_TRIGGER) || null;
    } catch {
        return null;
    }
};

export const clearLoginTrigger = () => {
    try {
        localStorage.removeItem(STORAGE_KEYS.LOGIN_TRIGGER);
    } catch {
        // ignore
    }
};

/**
 * Removes all cookies by parsing document.cookie and removing each one
 */
const clearAllCookies = () => {
    // Get all cookies from document.cookie
    const cookies = document.cookie.split(';');
    const hostname = window.location.hostname;
    
    cookies.forEach(cookie => {
        const cookieName = cookie.split('=')[0].trim();
        if (cookieName) {
            // Remove cookie with different path/domain combinations
            Cookies.remove(cookieName);
            Cookies.remove(cookieName, { path: '/' });
            Cookies.remove(cookieName, { domain: hostname });
            Cookies.remove(cookieName, { domain: `.${hostname}` });
        }
    });
};

/**
 * Clears all storage, cookies, and Google OAuth session data
 * Used during logout to ensure complete cleanup
 */
export const clearAllStorage = () => {
    try {
        // Clear all localStorage
        localStorage.clear();

        // Clear all sessionStorage
        sessionStorage.clear();

        // Clear all cookies
        clearAllCookies();

        // Disable Google One Tap auto-select
        if (window.google?.accounts?.id) {
            window.google.accounts.id.disableAutoSelect();
        }

        // Revoke Google token if available (legacy gapi)
        if (window.gapi?.auth2) {
            const authInstance = window.gapi.auth2.getAuthInstance();
            if (authInstance?.isSignedIn?.get()) {
                authInstance.signOut().then(() => {
                    authInstance.disconnect();
                });
            }
        }
    } catch (error) {
        console.error("Error clearing storage:", error);
    }
};
